import { getApiUrl } from "../utils/general.js";
import axios from "axios";

const ImportService = {
  getLastImportDate: async () => {
    try {
      const { data } = await axios.get(
        `${getApiUrl()}/importstatus/lastImport`
      );
      return data;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },
};

export default ImportService;
